import { useState } from 'react'
import { useNavigate } from 'react-router'
import clsx from 'clsx'
import { GoChevronLeft } from 'react-icons/go'
import { FaCheckCircle } from 'react-icons/fa'

const Display: React.FC = () => {
  const navigate = useNavigate()
  const [theme, setTheme] = useState('dark')

  return (
    <div className="flex h-full w-full flex-col text-sm">
      <div className="flex h-[50px] items-center pl-[10px] text-xl font-semibold">
        <div className="flex items-center">
          <button
            type="button"
            className="hover-main mr-[10px] flex h-[30px] w-[30px] items-center justify-center rounded-full"
            onClick={() => {
              navigate('../accessibility')
            }}
          >
            <GoChevronLeft />
          </button>
          <h1>Display</h1>
        </div>
      </div>
      <div className="text-sub pt-[15px] pb-[25px] pl-[25px]">
        You can select your preferred theme styles here.
      </div>
      <div className="text-sub flex w-full pl-[25px]">
        <button
          type="button"
          className={clsx(
            'flex h-[80px] w-[160px] items-center rounded-[10px] bg-black',
            {
              'border-blue border border-2': theme === 'dark',
            },
          )}
          onClick={() => {
            if (theme !== 'dark') {
              document.documentElement.setAttribute('data-theme', 'dark')
              setTheme('dark')
            }
          }}
        >
          <div className="hover-main ml-[15px] rounded-full p-[10px]">
            <div className="border-theme h-[20px] w-[20px] rounded-full border border-2 bg-white">
              {theme === 'dark' && (
                <FaCheckCircle className="text-blue h-full w-full" />
              )}
            </div>
          </div>

          <h1 className="pl-[15px] text-lg font-semibold text-white">Dark</h1>
        </button>
        <button
          type="button"
          className={clsx(
            'ml-[15px] flex h-[80px] w-[160px] items-center rounded-[10px] bg-white',
            {
              'border-blue border border-2': theme === 'light',
            },
          )}
          onClick={() => {
            if (theme !== 'light') {
              document.documentElement.setAttribute('data-theme', 'light')
              setTheme('light')
            }
          }}
        >
          <div className="hover-sub ml-[15px] rounded-full p-[10px]">
            <div className="border-theme h-[20px] w-[20px] rounded-full border border-2 bg-white">
              {theme === 'light' && (
                <FaCheckCircle className="text-blue h-full w-full" />
              )}
            </div>
          </div>

          <h1 className="pl-[15px] text-lg font-semibold text-black">Light</h1>
        </button>
      </div>
    </div>
  )
}

export default Display
